import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='card' subtitle='object' mdxType="Item">
	Customize the appearance and behavior of the card fields in the checkout form.
	<Group summary='Properties' mdxType="Group">
		<Item title='cardholderName' subtitle='object' mdxType="Item">
			Options for the cardholder name input field.
			<Group summary='Properties' mdxType="Group">
				<Item title='required' subtitle='boolean' mdxType="Item">
					Whether the cardholder name is required. Only works if the cardholder name is visible.
				</Item>
				<Item title='visible' subtitle='boolean' label='Deprecated' mdxType="Item">
					Whether the cardholder name input field should be visible. This property is **deprecated**, set it on your
					Dashboard instead.
				</Item>
				<Item title='placeholder' subtitle='string | (options: { locale: string }) => string' mdxType="Item">
					The placeholder text to display in the cardholder name input field. It can be either a string or a function
					that returns a string. The function receives an options object as first argument.
				</Item>
			</Group>
		</Item>
		<Item title='cardNumber' subtitle='object' mdxType="Item">
			Customize the placeholder of the card number field.
			<Group summary='Properties' mdxType="Group">
				<Item title='placeholder' subtitle='string | (options: { locale: string }) => string' mdxType="Item">
					The placeholder text to display in the cardholder number input field. It can be either a string or a function
					that returns a string. The function receives an options object as first argument.
				</Item>
			</Group>
		</Item>
		<Item title='expiryDate' subtitle='object' mdxType="Item">
			Customize the placeholder of the expiry date field.
			<Group summary='Properties' mdxType="Group">
				<Item title='placeholder' subtitle='string | (options: { locale: string }) => string' mdxType="Item">
					The placeholder text to display in the expiry date input field. It can be either a string or a function that
					returns a string. The function receives an options object as first argument.
				</Item>
			</Group>
		</Item>
		<Item title='cvv' subtitle='object' mdxType="Item">
			Customize the placeholder of the CVV field.
			<Group summary='Properties' mdxType="Group">
				<Item title='placeholder' subtitle='string | (options: { locale: string }) => string' mdxType="Item">
					The placeholder text to display in the CVV input field. It can be either a string or a function that returns a
					string. The function receives an options object as first argument.
				</Item>
			</Group>
		</Item>
	</Group>
    </Item>
    <Item title='paypal' subtitle='object' mdxType="Item">
	Options for using PayPal as a payment method.
	<Group summary='Properties' mdxType="Group">
		<Item title='buttonColor' subtitle='"gold" | "blue" | "silver" | "white" | "black"' mdxType="Item">
			The color of the PayPal button.
		</Item>
		<Item title='buttonShape' subtitle='"pill" | "rect"' mdxType="Item">
			The shape of the PayPal button.
		</Item>
		<Item title='buttonSize' subtitle='"small" | "medium" | "large" | "responsive"' mdxType="Item">
			The size of the PayPal button.
		</Item>
		<Item title='buttonHeight' subtitle='number' mdxType="Item">
			The height of the PayPal button, in pixels.
		</Item>
		<Item title='buttonLabel' subtitle='"checkout" | "credit" | "pay" | "buynow" | "paypal" | "installment"' mdxType="Item">
			The label displayed on the PayPal button.
		</Item>
		<Item title='buttonTagline' subtitle='boolean' mdxType="Item">
			Whether to display the PayPal tagline beneath the button.
		</Item>
		<Item title='onClick' subtitle='() => void' mdxType="Item">
			A function to be called when the PayPal button is clicked.
		</Item>
	</Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      